import { type FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const OmniSignDocumentsError: FunctionComponent = () => (
  <div className="m-auto">
    <PleaseWaitOverlay
      icon="error"
      title="There has been an error fetching your documents"
      labelLine1="Please refresh the page to try again. If this error persists, please reach out to Ideal4Finance"
    />
  </div>
);

export default OmniSignDocumentsError;
